import React, { ReactChild } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import es from 'date-fns/locale/es'

import { MuiPickersUtilsProvider } from '@material-ui/pickers'

interface CommonB2CProviderProps {
  children: ReactChild
}

export default function CommonB2CProvider({ children }: CommonB2CProviderProps) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
      {children}
    </MuiPickersUtilsProvider>
  )
}
